export const QUESTION_TOPICS = [
  {
    id: "work",
    label: "Work",
    questions: [
      "What are you passionate about?",
      "Best advice you've ever received?",
      "What are you really good at?",
      "What was the last book you read?",
      "What makes you happy?",
      "What's a project you're proud of?",
      "How do you handle tight deadlines?",
    ],
  },
  {
    id: "life",
    label: "Life",
    questions: [
      "Life-changing concert?",
      "What's on your travel bucket list?",
      "Best album ever?",
      "A movie that made you cry?",
      "Best trip you've ever taken?",
      "A hobby you can't shut up about?",
    ],
  },
  {
    id: "fun",
    label: "Fun",
    questions: [
      "What would your superpower be?",
      "Favorite Food?",
      "Favorite cereal growing up?",
      "Worst ingredients to fill a burrito with?",
      "What's your pet peeve?",
      "What's your spirit animal?",
      "Go-to karaoke song?",
      "Desert island snack?",
    ],
  },
]

export const ALL_QUESTIONS = QUESTION_TOPICS.flatMap((topic) => topic.questions)

export function topicFor(question) {
  const topic = QUESTION_TOPICS.find((item) => item.questions.indexOf(question) !== -1)
  return topic ? topic.id : "fun"
}

export function topicLabel(topicId) {
  const topic = QUESTION_TOPICS.find((item) => item.id === topicId)
  return topic ? topic.label : "All"
}

export function questionsFor(topicId) {
  if (!topicId || topicId === "all") return ALL_QUESTIONS.slice()
  const topic = QUESTION_TOPICS.find((item) => item.id === topicId)
  return topic ? topic.questions.slice() : ALL_QUESTIONS.slice()
}

// Nested groups used by the older Vue apply-flow recorder.
const questions = [
  [
    "What are you passionate about?",
    "Life-changing concert?",
    "What would your superpower be?",
    "Favorite Food?",
    "Best advice you've ever received?",
  ],
  [
    "What's on your travel bucket list?",
    "Best album ever?",
    "What are you really good at?",
    "Favorite cereal growing up?",
    "A movie that made you cry?",
  ],
  [
    "Worst ingredients to fill a burrito with?",
    "What's your pet peeve?",
    "What was the last book you read?",
    "What's your spirit animal?",
    "What makes you happy?",
  ]
]

export default questions
